import type { Theme } from '@mui/material';

export const styles = {
  warning: (theme: Theme) => ({
    color: theme.colors.warning[500],
  }),
};
